"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListTiersQuerySchema = exports.UpdateTierBodySchema = exports.CreateTierBodySchema = exports.ListTiersResponseSchema = exports.UpdateTierResponseSchema = exports.CreateTierResponseSchema = exports.GetTierResponseSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
const common_1 = require("../common");
/**
 * Responses
 */
exports.GetTierResponseSchema = common_1.TierSchema;
exports.CreateTierResponseSchema = common_1.TierSchema;
exports.UpdateTierResponseSchema = common_1.TierSchema;
exports.ListTiersResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.GetTierResponseSchema);
/**
 * Body
 */
exports.CreateTierBodySchema = (0, core_1.StrictObject)({
    name: core_1.NameSchema,
    description: core_1.DescriptionSchema,
    maxDailySpend: (0, core_1.OptionalNullable)(core_1.MoneySchema),
    fee: ruby_1.TierFeeSchema,
    payment: ruby_1.PaymentModelSchema,
    hosted: core_1.EnabledSchema,
    private: core_1.EnabledSchema,
    status: ruby_1.TierStatusSchema,
});
exports.UpdateTierBodySchema = (0, core_1.StrictObject)({
    name: typebox_1.Type.Optional(core_1.NameSchema),
    description: typebox_1.Type.Optional(core_1.DescriptionSchema),
    maxDailySpend: (0, core_1.OptionalNullable)(core_1.MoneySchema),
    fee: typebox_1.Type.Optional(ruby_1.TierFeeSchema),
    payment: typebox_1.Type.Optional(ruby_1.PaymentModelSchema),
    private: typebox_1.Type.Optional(core_1.EnabledSchema),
    hosted: typebox_1.Type.Optional(core_1.EnabledSchema),
    status: typebox_1.Type.Optional(ruby_1.TierStatusSchema),
});
/**
 * Parameters
 */
exports.ListTiersQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({});
